export const Header = () => {

  return (
    <div className="flex flex-col gap-2 md:gap-6 w-screen text-center">
      <h1 className="font-space font-bold text-3xl">Quotes Anime</h1>
    </div>
  );
};
